import { axiosInstance } from "./index.ts";

export enum CampaignPipelineStage {
	PENDING_ACCEPTANCE = "pending_acceptance",
	CONCEPTING = "concepting",
	VIDEO_PRODUCTION = "video_production",
	APPROVED = "approved",
	GO_LIVE = "go_live",
	PAYMENT_PROCESS = "payment_process",
	DONE = "done",
	DROPPED = "dropped",
}

export const ACTIVE_PIPELINE_STAGES: CampaignPipelineStage[] = [
	CampaignPipelineStage.PENDING_ACCEPTANCE,
	CampaignPipelineStage.CONCEPTING,
	CampaignPipelineStage.VIDEO_PRODUCTION,
	CampaignPipelineStage.APPROVED,
	CampaignPipelineStage.GO_LIVE,
	CampaignPipelineStage.PAYMENT_PROCESS,
	CampaignPipelineStage.DONE,
];

export interface CampaignStatusTrackingCreator {
	assignmentId: string;
	creatorId: string;
	handle: string;
	displayName: string;
	avatarUrl: string | null;
	marketName: string | null;
	creatorBlockId: string | null;
	deepLinkBlockId: string | null;
	stage: CampaignPipelineStage;
	rawStageValue?: string | null;
}

export interface CampaignStatusTrackingInvalidCreator {
	assignmentId: string;
	creatorId: string;
	handle: string;
	rawStageValue: string | null;
}

export interface CampaignStatusTrackingData {
	campaignId: string;
	campaignName: string;
	totalRoster: number;
	droppedCount: number;
	stageCounts: Record<CampaignPipelineStage, number>;
	creatorsByStage: Record<CampaignPipelineStage, CampaignStatusTrackingCreator[]>;
	invalidCreators: CampaignStatusTrackingInvalidCreator[];
	lastUpdatedAt: string | null;
	reconciliation: {
		expectedTotal: number;
		summedTotal: number;
		delta: number;
		mismatch: boolean;
	};
}

export const campaignStatusTrackingAPI = {
	getByCampaignId: async (campaignId: string): Promise<CampaignStatusTrackingData> => {
		const res = await axiosInstance.get(`/campaigns/${campaignId}/status-tracking`);
		return res.data;
	},
};
